import React, { PropTypes, Component } from 'react'
import {Link} from 'react-router-dom';
import SimpleList from '../simplelist';
import withSiblings from '../../../containers/withsiblings';
import SectionTitle from '../../resorthome/sectiontitle';
class SiblingsList extends Component {

    render() {
        const { siblings, parent } = this.props
        const items = siblings && siblings.map((node) => { return {url: `/experiences/${ node.title.replace(' ', '_') }/${ node.db_id }` , title: node.title}})
        return (
            <div>
                <SectionTitle title={ this.props.title || ( parent && parent.title ) }/>
                <SimpleList items={ items }/>
            </div> 
        )
    }
}

const Siblings = (props) => {
    const { parentId, ...rest} = props
    const Comp = parentId && withSiblings(SiblingsList, parentId)
    return (
        <div>
            { parentId && <Comp {...rest}/> }
        </div>
    )
    // return withSiblings(SiblingsList, parentId)
}
export default Siblings



// WEBPACK FOOTER //
// ./src/components/pagescreen/siblingslist/index.js